/* src/store/index.js — complete Vuex store
   (Vue 3 + Vuex 4) */

   import { createStore } from 'vuex'
   import taxonomyFrontend from './modules/taxonomyFrontend.js'; // <— import here

   export default createStore({
     // strict: import.meta.env.DEV,
     modules: {
     /* ──────────────────────────────────────────────────────────── UI ─── */
     ui: {
       namespaced: true,
       state: () => ({
         /* layout / navigation */
         currentView: 'attributeManagement',
         searchQuery: '',
         horizontal:  true,
         collapsable:true,
   
         /* change-tracking */
         hasUnsavedChanges:false,
         versionDescription:'',
         showBackupVersions:false,
   
         /* toast */
         snackbar:{ show:false, message:'', color:'success' },
   
         /* filter-editor (right panel) */
         editableFilters:{},
         editableFilterNames:{},
         newFilterName:'',
         newFilterValues:{},
         expandedFilters:[],
         editingFilterName:null,
         editingValue:{ filter:null, index:null },
   
         /* attribute-editor helpers */
         attributeSort:'display_name',
         isAttributeEditorFullscreen:false,
         expandedAttributeValues:{}, // This is where expandedAttributeValues is
         expandedCategories:{},
         newAttributeValue:{},        // { [attrId]: '' }

       }),
   
       getters:{
         currentView:s=>s.currentView,
         searchQuery:s=>s.searchQuery,
         snackbar:s=>s.snackbar,
         editableFilters:s=>s.editableFilters,
         editableFilterNames:s=>s.editableFilterNames,
         newFilterName:s=>s.newFilterName,
         newFilterValues:s=>s.newFilterValues,
         expandedFilters:s=>s.expandedFilters,
         editingFilterName:s=>s.editingFilterName,
         editingValue:s=>s.editingValue,
         layoutOpts:s=>({ horizontal:s.horizontal, collapsable:s.collapsable }),
         attributeEditorTableHeight:s=>
           s.isAttributeEditorFullscreen ? 'calc(100vh - 230px)'
                                         : 'calc(100vh - 390px)',
            attributeSort:s=>s.attributeSort, // Expose attributeSort for taxonomy getter
            expandedAttributeValues:s=>s.expandedAttributeValues, // Expose expandedAttributeValues
       },
   
       mutations:{
         SET_VIEW         (s,v){ s.currentView=v },
         SET_SEARCH       (s,q){ s.searchQuery=q },
         SET_LAYOUT       (s,{horizontal,collapsable}){
           if(horizontal!==undefined)  s.horizontal =horizontal
           if(collapsable!==undefined) s.collapsable=collapsable
         },
         SET_BACKUP_VIS   (s,v){ s.showBackupVersions=v },
         SET_VERSION_DESC (s,v){ s.versionDescription=v },
         SET_UNSAVED      (s,v){ s.hasUnsavedChanges=v },
   
         /* toast */
         SET_SNACKBAR     (s,{show,message='',color='success'}){
           s.snackbar={ show,message,color }
         },
   
         /* filter-editor */
         SET_EDITABLE_FILTERS     (s,v){ s.editableFilters=v },
         SET_EDITABLE_FILTER_NAMES(s,v){ s.editableFilterNames=v },
         SET_NEW_FILTER_NAME      (s,v){ s.newFilterName=v },
         SET_NEW_FILTER_VALUES    (s,v){ s.newFilterValues=v },
         SET_EXPANDED_FILTERS     (s,v){ s.expandedFilters=v },
         SET_EDITING_FILTER_NAME  (s,v){ s.editingFilterName=v },
         SET_EDITING_VALUE        (s,v){ s.editingValue=v },
   
         /* attribute-editor helpers */
         SET_ATTRIBUTE_SORT (s,v){ s.attributeSort=v },
         TOGGLE_ATTRIBUTE_EDITOR_FULLSCREEN(s){
           s.isAttributeEditorFullscreen=!s.isAttributeEditorFullscreen
         },
         TOGGLE_EXPAND_VALUES     (s,id){
           s.expandedAttributeValues={ ...s.expandedAttributeValues, [id]:!s.expandedAttributeValues[id] }
         },
         TOGGLE_EXPAND_CATEGORIES (s,id){
           s.expandedCategories={ ...s.expandedCategories, [id]:!s.expandedCategories[id] }
         },
         SET_NEW_ATTRIBUTE_VALUE  (s,{attrId,txt}){
           s.newAttributeValue={ ...s.newAttributeValue, [attrId]:txt }
         },
       },
   
       actions:{
         changeView ({commit},v){ commit('SET_VIEW',v) },
         search     ({commit},q){ commit('SET_SEARCH',q) },
         toggleLayout({commit,state},key){
           commit('SET_LAYOUT',{ [key]:!state[key] })
         },
   
         /* shared toast */
         showSnackbar({commit},{message,color='success',duration=2000}){
           commit('SET_SNACKBAR',{ show:true,message,color })
           setTimeout(()=>commit('SET_SNACKBAR',{ show:false }),duration)
         },
   
         /* filter-editor utilities */
         toggleEditableFilters({commit,state}){
           commit('SET_EDITABLE_FILTERS',
             !Object.keys(state.editableFilters).length)
         },
         clearEditableFilters({commit}){
           commit('SET_EDITABLE_FILTERS',{})
           commit('SET_EDITABLE_FILTER_NAMES',{})
           commit('SET_NEW_FILTER_NAME','')
           commit('SET_NEW_FILTER_VALUES',{})
           commit('SET_EXPANDED_FILTERS',[])
           commit('SET_EDITING_FILTER_NAME',null)
           commit('SET_EDITING_VALUE',{ filter:null,index:null })
         },
       },
     },
     taxonomyFrontend,
   
     /* ────────────────────────────────────────────────────── TAXONOMY ─── */
     taxonomy:{
       namespaced:true,
       state:()=>({
         /* raw multi-root taxonomy */
         taxonomyData:{},
         selectedTopLevelNode:null,
         topLevelNodes: [],
   
         /* vue3-tree rendering */
         treeItems:[],
         expandedNodes:new Set(),
         tree:null,                   // legacy
         nodeIdMap:{},
         nodeIdsByType:{},
   
         /* selection / filter panel */
         selectedNode:null,
         selectedNodeId:null,
   
         /* attributes */
         attributes:{},
   
         /* master filter lists */
         allFiltersMap:{},
         filterIdsByName:{},
         allFilterNames:[],
   
         /* constants */
         keysToSkip:['name','url','total_items','attribute_ids'],
   
         /* versions */
         versions:[],
         loadedVersion:null,
   
         sourceColors:{
           base_source:'#F59E0B', about_you:'#3B82F6', zalando:'#EF4444',
           galaxus_fashion:'#10B981', ochsner:'#00CED1', other_source:'#9D4EDD',
         },
   
         attributeTableHeaders:[
           {title:'ID',key:'attribute_id'},
           {title:'Name',key:'name'},
           {title:'Display Name',key:'display_name'},
           {title:'Description',key:'description'},
           {title:'Values',key:'values'},
           {title:'Attribute Group',key:'attribute_group'},
           {title:'Data Type',key:'data_type'},
           {title:'Booleans (1)',key:'booleans_group_1'},
           {title:'Booleans (2)',key:'booleans_group_2'},
           {title:'Booleans (3)',key:'booleans_group_3'},
           {title:'Sort Order',key:'sort_order'},
           {title:'Attribute Level',key:'attribute_level'},
           {title:'Attribute Unit',key:'attribute_unit'},
           {title:'Notes',key:'notes'},
           {title:'Attribute Sources',key:'filter_sources'},
           {title:'Categories',key:'categories'},
           {title:'Actions',key:'actions',width:60},
        ]
       }),
   
       getters:{
         attributes:s=>s.attributes,
         taxonomyData:s=>s.taxonomyData,
         keysToSkip:s=>s.keysToSkip,
         treeItems:s=>s.treeItems,
         topLevelNodes:s=>s.topLevelNodes,
         expandedNodes:s=>s.expandedNodes,
         selectedNode:s=>s.selectedNode,
         selectedNodeId:s=>s.selectedNodeId,
         allFilterNames:s=>s.allFilterNames,
         getDisplayName:s=>attr=>{
           if(attr.display_name&&typeof attr.display_name==='object')
             return attr.display_name.en||''
           if(typeof attr.display_name==='string') return attr.display_name
           return attr.name||''
         },
         
            // Updated sortedAttributes getter
            sortedAttributes: (state, getters, rootState, rootGetters) => {
                const arr = Object.entries(state.attributes).map(([key, rawObj]) => {
                    // Ensure attribute_id is present, though it should be from state.attributes
                    if (!rawObj.attribute_id) {
                        rawObj.attribute_id = parseInt(key, 10);
                    }
                    // Add this line to create valuesArray for each item
                    rawObj.valuesArray = getters.getValuesArray(rawObj); // Use local getter
                    return rawObj;
                });

                const created = arr.filter((a) => a.justCreated);
                const rest = arr.filter((a) => !a.justCreated);

                const attributeSort = rootGetters['ui/attributeSort']; // Access from root getters

                if (attributeSort === "display_name") {
                    rest.sort((a, b) =>
                        (getters.getDisplayName(a) || "").localeCompare( // Use local getter
                            getters.getDisplayName(b) || ""               // Use local getter
                        )
                    );
                } else if (attributeSort === "attribute_id") {
                    rest.sort((a, b) => a.attribute_id - b.attribute_id);
                }
                return [...created, ...rest];
            },

          filteredAttributes: (state, getters, rootState, rootGetters) => {
            const q = (rootGetters['ui/searchQuery'] || "").trim().toLowerCase();
            let arr = getters.sortedAttributes; // Use the sortedAttributes getter
            if (q) {
              arr = arr.filter((item) => {
                const nameMatch = (item.name || "").toLowerCase().includes(q);
                // Add display name matching using the helper function
                const displayNameMatch = getters.getDisplayName(item)
                  .toLowerCase()
                  .includes(q);
                const idMatch = String(item.attribute_id).includes(q);
                return nameMatch || displayNameMatch || idMatch;
              });
            }
            return arr;
          },
         getValuesArray:s=>attr=>attr.valuesArray||Object.values(attr.values||{}),
            // New getter factory for shouldDisplayValue
            shouldDisplayValue: (state, getters, rootState, rootGetters) => (item, index) => {
                // Access expandedAttributeValues from the 'ui' module's state via rootState
                return rootState.ui.expandedAttributeValues[item.attribute_id] || index < 7;
            },

            // New getter factory for getValueChipStyle
            getValueChipStyle: (state, getters) => (filterName, val) => {
                try {
                    const sources = getters.getFilterValueSourcesForSelectedNode(
                        filterName,
                        val
                    );

                    if (!sources || sources.length === 0) {
                        return {
                            backgroundColor: "#f5f5f5",
                            color: "#000",
                        };
                    }

                    const firstSource = sources[0];
                    const sourceColors = state.sourceColors; // Access from local state
                    const color = sourceColors[firstSource] || "#AAA";

                    return {
                        backgroundColor: color,
                        color: "#fff",
                    };
                } catch (e) {
                    console.error("Error in getValueChipStyle:", e);
                    return {
                        backgroundColor: "#f5f5f5",
                        color: "#000",
                    };
                }
            },

            // REVISED getFilterValueSourcesForSelectedNode
            getFilterValueSourcesForSelectedNode: (state, getters) => (filterName, filterValue) => {
                if (!state.selectedNodeId) return [];

                try {
                    const nodeId = state.selectedNodeId;
                    const nodeMap = state.nodeIdMap;
                    const nodeData = nodeMap[nodeId];

                    // Check node sources first
                    if (
                        nodeData &&
                        nodeData.sources &&
                        nodeData.sources.filters &&
                        nodeData.sources.filters[filterName] &&
                        nodeData.sources.filters[filterName].values &&
                        nodeData.sources.filters[filterName].values[filterValue]
                    ) {
                        return Array.from(
                            nodeData.sources.filters[filterName].values[filterValue]
                        );
                    }

                    // Look in attribute data if not found in node
                    let attrId = null;
                    for (const id in state.attributes) { // Use state.attributes directly
                        const attr = state.attributes[id];
                        const displayName = getters.getDisplayName(attr); // Use the getDisplayName getter

                        // Add the more robust filterName matching logic here
                        const name = attr.name;
                        if (displayName === filterName || name === filterName ||
                            (filterName.includes('[') && filterName.split('[')[0].trim() === displayName && filterName.split('[')[1].replace(']', '').trim() === name)) {
                            attrId = parseInt(id, 10);
                            break;
                        }
                    }

                    if (attrId !== null) {
                        const attr = state.attributes[attrId]; // Use state.attributes directly
                        if (attr && attr.values) {
                            for (const valueId in attr.values) {
                                if (attr.values[valueId].value_en === filterValue) {
                                    return attr.values[valueId].sources
                                        ? Array.from(attr.values[valueId].sources)
                                        : [];
                                }
                            }
                        }
                    }

                    return [];
                } catch (e) {
                    console.error("Error in getFilterValueSourcesForSelectedNode:", e);
                    return [];
                }
            },
       },
   
       mutations:{
         SET_TAXONOMY_DATA         (s,v){ s.taxonomyData=v },
         SET_SELECTED_TOP_LEVEL_NODE(s,v){ s.selectedTopLevelNode=v },
         SET_TOP_LEVEL_NODES       (s,v){ s.topLevelNodes=v },
         SET_TREE_ITEMS            (s,v){ s.treeItems=v },
         SET_EXPANDED_NODES        (s,v){ s.expandedNodes=v },
         SET_NODE_ID_MAP           (s,v){ s.nodeIdMap=v },
         SET_NODE_IDS_BY_TYPE      (s,v){ s.nodeIdsByType=v },
         SET_SELECTED_NODE_ID      (s,v){ s.selectedNodeId=v },
         SET_SELECTED_NODE         (s,v){ s.selectedNode=v },
         SET_ATTRIBUTES            (s,v){ s.attributes=v },
         UPSERT_ATTRIBUTE          (s,attr){ s.attributes={...s.attributes,[attr.attribute_id]:attr} },
         DELETE_ATTRIBUTE          (s,id){ const{[id]:_,...rest}=s.attributes; s.attributes=rest },
         SET_ALL_FILTERS_MAP       (s,v){ s.allFiltersMap=v },
         SET_FILTER_IDS_BY_NAME    (s,v){ s.filterIdsByName=v },
         SET_ALL_FILTER_NAMES      (s,v){ s.allFilterNames=v },
         SET_VERSIONS              (s,v){ s.versions=v },
         SET_LOADED_VERSION        (s,v){ s.loadedVersion=v },
       },
   
       actions:{
         /* ───────────────────────────── helpers ───────────────────────── */
         getNextAvailableAttributeId({state}){
           const list=state.taxonomyData._metadata?.historicalAttributeIds||[]
           if(!list.length) return '1000'
           const max=Math.max(...list.map(id=>parseInt(id,10)))
           return String(max+1)
         },
   
         nextValueId(_,attr){
           const hist=attr.historicalValueIds||[]
           const cur =Object.keys(attr.values||{})
           const all =[...new Set([...hist,...cur])]
           if(!all.length) return '70000001'
           const max=Math.max(...all.map(i=>parseInt(i,10)))+1
           return String(max).padStart(8,'0')
         },
   
         removeAttributeIdEverywhere({getters}, {obj,attrId}){
           const skip=getters.keysToSkip
           if(!obj||typeof obj!=='object') return
           if(Array.isArray(obj)){
             obj.forEach(el=>this.dispatch('taxonomy/removeAttributeIdEverywhere',{obj:el,attrId}))
             return
           }
           if(Array.isArray(obj.filters))
             obj.filters=obj.filters.filter(id=>parseInt(id)!==parseInt(attrId))
           if(Array.isArray(obj.attribute_ids))
             obj.attribute_ids=obj.attribute_ids.filter(id=>parseInt(id)!==parseInt(attrId))
           if(Array.isArray(obj.subcategories))
             obj.subcategories.forEach(sub=>this.dispatch('taxonomy/removeAttributeIdEverywhere',{obj:sub,attrId}))
           for(const[k,v] of Object.entries(obj)){
             if(skip.includes(k)||['filters','attribute_ids','subcategories','sources','name'].includes(k)) continue
             this.dispatch('taxonomy/removeAttributeIdEverywhere',{obj:v,attrId})
           }
         },
   
         removeAttributeIdFromAllTopLevels({state,dispatch},attrId){
           for(const k of Object.keys(state.taxonomyData)){
             if(state.keysToSkip.includes(k)) continue
             dispatch('removeAttributeIdEverywhere',{obj:state.taxonomyData[k],attrId})
           }
         },
   
         gatherAllFilters({state,getters,commit}){
           const map={}, ids={}, counts={}
           for(const [id,a] of Object.entries(state.attributes)){
             const base=a.name||`Attribute ${id}`
             const disp=getters.getDisplayName(a)
             let name=(disp===base)?disp:`${disp} [${base}]`
             if(counts[name]){ counts[name]++; name=`${name} (ID: ${id})` }
             else counts[name]=1
             ids[name]=Number(id)
             map[name]=map[name]||new Set()
           }
           commit('SET_ALL_FILTERS_MAP',map)
           commit('SET_FILTER_IDS_BY_NAME',ids)
           commit('SET_ALL_FILTER_NAMES',Object.keys(map).sort())
         },
   
         refreshSelectedNodeFilters({state,getters,commit,dispatch}){
           const sel=state.selectedNodeId
           if(!sel){ commit('SET_SELECTED_NODE',null); return }
           const node=state.nodeIdMap[sel]
           if(!node){ commit('SET_SELECTED_NODE',null); return }
           const ids=Array.isArray(node.filters)?node.filters:[]
           const dict={}
           ids.forEach(id=>{
             const attr=state.attributes[id]
             if(!attr){ dict[`Unknown #${id}`]=[] }
             else{
               const d=getters.getDisplayName(attr)
               const b=attr.name||''
               const key=(d===b)?d:`${d} [${b}]`
               dict[key]=getters.getValuesArray(attr).map(v=>v.value_en)
             }
           })
           commit('SET_SELECTED_NODE',{ name:node.name||'(untitled node)',filters:dict })
           commit('ui/SET_EDITABLE_FILTERS',JSON.parse(JSON.stringify(dict)),{root:true})
           commit('ui/SET_EDITABLE_FILTER_NAMES',Object.fromEntries(Object.keys(dict).map(n=>[n,n])),{root:true})
           commit('ui/SET_EXPANDED_FILTERS',[],{root:true})
         },
   
         /* ───────────────────────────── CRUD ─────────────────────────── */
         async createNewAttribute({dispatch,commit,state},customName){
           const id= await dispatch('getNextAvailableAttributeId')
           if(!id){
             dispatch('ui/showSnackbar',{message:'Failed to generate a unique attribute ID',color:'error'},{root:true})
             return null
           }
           const name=(typeof customName==='string'&&customName.trim())?customName.trim():`Attribute ${id}`
           const obj={
             attribute_id:id,
             name,
             display_name:{en:name,de:'',fr:'',it:''},
             description:'',
             data_type:'text',
             always_required:false,
             is_image_attribute:false,
             is_closed_list:false,
             filter_attribute:false,
             critical_attribute:false,
             secondary_allowed:false,
             customer_facing:true,
             notes:'',
             sort_order:'Alphabetical',
             attribute_level:'Product',
             attribute_unit:'',
             justCreated:true,
             is_category_type_attribute:false,
             attribute_group:null,
             values:{},
             historicalValueIds:[],
             translations:{value_de:[],value_fr:[],value_it:[]},
             sources:[]
           }
           commit('UPSERT_ATTRIBUTE',obj)
           if(!state.taxonomyData._metadata) state.taxonomyData._metadata={}
           if(!state.taxonomyData._metadata.historicalAttributeIds) state.taxonomyData._metadata.historicalAttributeIds=[]
           state.taxonomyData._metadata.historicalAttributeIds.push(id)
           dispatch('gatherAllFilters')
           dispatch('ui/showSnackbar',{message:`Created new attribute #${id}`,color:'success'},{root:true})
           return obj
         },
   
         deleteAttribute({commit,dispatch,state},item){
           const id=item.attribute_id
           commit('DELETE_ATTRIBUTE',id)
           dispatch('removeAttributeIdFromAllTopLevels',id)
           dispatch('loadTopLevelNode')
           if(state.selectedNodeId) dispatch('refreshSelectedNodeFilters')
           dispatch('gatherAllFilters')
           dispatch('ui/showSnackbar',{message:`Attribute #${id} deleted`,color:'success'},{root:true})
         },
   
         async addAttributeValue({rootState,commit,dispatch,getters},item){
           const txt=(rootState.ui.newAttributeValue[item.attribute_id]||'').trim()
           if(!txt) return
           const valId = await dispatch('nextValueId', item);
           if(!item.values) item.values={}
           item.values[valId]={
             value_en:txt,value_de:'',value_fr:'',value_it:'',
             value_sort_index:Object.keys(item.values).length,
             notes:'',sources:[]
           }
           if(!item.historicalValueIds) item.historicalValueIds=[]
           item.historicalValueIds.push(valId)
           item.valuesArray=getters.getValuesArray(item)
           commit('UPSERT_ATTRIBUTE',{...item})
           commit('ui/SET_NEW_ATTRIBUTE_VALUE',{attrId:item.attribute_id,txt:''},{root:true})
         },
   
         removeAttributeValue({commit,state},{item,index}){
           const attr=state.attributes[item.attribute_id]
           if(!attr) return
           const vo=attr.valuesArray[index]
           if(!vo) return
           const key=Object.keys(attr.values).find(k=>attr.values[k].value_en===vo.value_en)
           if(key){
             const{[key]:_,...rest}=attr.values
             attr.values=rest
           }
           attr.valuesArray.splice(index,1)
           commit('UPSERT_ATTRIBUTE',{...attr})
         },
   
         /* ───────────────────────────── tree / selection ────────────────── */
         loadTaxonomyData({commit},data){ commit('SET_TAXONOMY_DATA',data) },

         setTopLevelNodes({commit},data){ commit('SET_TOP_LEVEL_NODES',data) },
   
         loadTopLevelNode({state,commit,dispatch},topId){
           if(topId!==undefined) commit('SET_SELECTED_TOP_LEVEL_NODE',topId)
           const sel=state.selectedTopLevelNode
           /* collect initial expansions only once */
           if(state.expandedNodes.size===0&&state.treeItems.length){
             const set=new Set()
             const walk=n=>{
               if(!n) return
               if(Array.isArray(n.children)&&n.children.length){
                 set.add(n.id)
                 n.children.forEach(walk)
               }
             }
             walk(state.treeItems[0])
             commit('SET_EXPANDED_NODES',set)
           }
           if(sel&&state.taxonomyData[sel]){
             const data=state.taxonomyData[sel]
             const convert=n=>({
               ...n,
               id:n.id||n.attribute_id||n.name,
               label:n.label||n.name||`Node ${Math.random()}`,
               children:(n.children||[]).map(convert)
             })
             const tree=[convert({...data,id:sel,label:data.name||sel})]
             const map={}, byType={}
             const walk=n=>{
               map[n.id]=n
               if(n.type){
                 byType[n.type]=byType[n.type]||[]
                 byType[n.type].push(n.id)
               }
               (n.children||[]).forEach(walk)
             }
             walk(tree[0])
             commit('SET_TREE_ITEMS',tree)
             commit('SET_NODE_ID_MAP',map)
             commit('SET_NODE_IDS_BY_TYPE',byType)
           }else{
             commit('SET_TREE_ITEMS',[])
             commit('SET_NODE_ID_MAP',{})
             commit('SET_NODE_IDS_BY_TYPE',{})
           }
         },
   
         loadTaxonomy({commit},blob){
           commit('SET_TREE',blob)
           const map={}
           const walk=n=>{
             if(n&&typeof n==='object'){
               if(n.id) map[n.id]=n
               if(Array.isArray(n.children)) n.children.forEach(walk)
             }
           }
           walk(blob)
           commit('SET_NODE_ID_MAP',map)
         },
        exportAttributesToCSV({state, getters, actions}) {
            const rows = getters.filteredAttributes;
            const escapeCSV = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
            const headers = [
                "attribute_id",
                "name",
                "display_name",
                "description",
                "values",
                "data_type",
                "always_required",
                "is_image_attribute",
                "is_closed_list",
                "filter_attribute",
                "critical_attribute",
                "secondary_allowed",
                "customer_facing",
                "notes",
                "sort_order",
                "attribute_level",
                "attribute_unit",
                "categories",
                "filter_sources",
                "value_sources",
                "value_notes",
                "translations",
            ];

            let csv = headers.map(escapeCSV).join(",") + "\n";

            rows.forEach((item) => {
                csv +=
                [
                    item.attribute_id,
                    item.name,
                    getters.getDisplayName(item), // ← fix
                    item.description,
                    (getters.getValuesArray(item) || []) // ← fix
                    .map((v) => v.value_en)
                    .join(";"),
                    item.data_type,
                    item.always_required ? "true" : "false",
                    item.is_image_attribute ? "true" : "false",
                    item.is_closed_list ? "true" : "false",
                    item.filter_attribute ? "true" : "false",
                    item.critical_attribute ? "true" : "false",
                    item.secondary_allowed ? "true" : "false",
                    item.customer_facing ? "true" : "false",
                    item.notes,
                    item.sort_order,
                    item.attribute_level,
                    item.attribute_unit,
                    (item.categories || []).join(";"),
                    (item.filter_sources || []).join(";"),
                    JSON.stringify(item.value_sources || {}),
                    JSON.stringify(item.value_notes || {}),
                    JSON.stringify(item.translations || {}),
                ]
                    .map(escapeCSV)
                    .join(",") + "\n";
            });

            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "attribute_editor_export.csv";
            a.click();
            URL.revokeObjectURL(url);
            actions.showSnackbar("CSV exported successfully!", "success");
        },
   
         handleNodeClick({state,getters,commit},node){
           const id=node?.id
           if(!id){
             commit('SET_SELECTED_NODE_ID',null)
             commit('SET_SELECTED_NODE',null)
             commit('ui/SET_EXPANDED_FILTERS',[],{root:true})
             return
           }
           commit('SET_SELECTED_NODE_ID',id)
           const data=state.nodeIdMap[id]||{}
           const dict={}
           const ids=data.attribute_ids||data.filters||[]
           ids.forEach(a=>{
             const attr=state.attributes[a]
             if(!attr){ dict[`Unknown #${a}`]=[] }
             else{
               dict[getters.getDisplayName(attr)]=getters.getValuesArray(attr).map(v=>v.value_en)
             }
           })
           commit('SET_SELECTED_NODE',{ name:data.name||node.label,filters:dict })
           commit('ui/SET_EDITABLE_FILTERS',JSON.parse(JSON.stringify(dict)),{root:true})
           commit('ui/SET_EDITABLE_FILTER_NAMES',Object.fromEntries(Object.keys(dict).map(n=>[n,n])),{root:true})
           commit('ui/SET_NEW_FILTER_NAME','',{root:true})
           commit('ui/SET_NEW_FILTER_VALUES',{}, {root:true})
           commit('ui/SET_EXPANDED_FILTERS',[],{root:true})
           commit('ui/SET_EDITING_FILTER_NAME',null,{root:true})
           commit('ui/SET_EDITING_VALUE',{filter:null,index:null},{root:true})
         },
   
         selectNode({commit},n){ commit('SET_SELECTED_NODE',n) },
   
         refreshVersions(){},
         loadTaxonomyVersion(){},
       },
     },
     },
   })